import { Card, Heading, HeadingVariants } from '@/ui'

import { Credentials } from './credentials'
import { SmsConsent } from './sms-consent'
import { TwoFactorAuthentication } from './two-factor-auth'
import { BaaAgreements } from './baa-agreements'

export const AccountDetailsCard = () => {
  return (
    <Card>
      <Heading variant={HeadingVariants.H2}>Account Details</Heading>
      <br />
      <Credentials />
      <br />
      <SmsConsent />
      <br />
      <TwoFactorAuthentication />
      <br />
      <BaaAgreements />
    </Card>
  )
}
